export const getters = {
  LIST: (state) => state.list,
  PAGINATION: (state) => state.pagination,
  COUNT: (state) => state.count,
}